import { useTranslation } from 'react-i18next'
import { ListCars } from '~/features/russia/Cars/ListCars'
import { Container, PageContainer } from '~/shared/ui/Layout'

export function ListCarsPageRussia() {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('cars')}>
      <Container>
        <ListCars />
      </Container>
    </PageContainer>
  )
}
